// BSV CHANGES
import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles({
  tableHeadCell: {
    fontSize: 14,
    fontWeight: 600,
    border: '1px solid #e0e0e0',
  },
  tableBodyCell: {
    fontSize: 13,
    border: '1px solid #e0e0e0',
  },
  navbarComponentHeading: {
    height: 24.7,
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#1c1939',
  },
});
